/**
 * keyStore.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Browser key storage using localStorage, scoped per user ID.
 * Scoping prevents a church login from finding a regular user's key (or vice
 * versa) when multiple accounts share the same browser.
 * ─────────────────────────────────────────────────────────────────────────────
 */

const privateKeyName = (userId) => `praysely_e2ee_private_key_${userId}`
const publicKeyName  = (userId) => `praysely_e2ee_public_key_${userId}`

export function savePrivateKey(userId, privateKeyB64) {
  localStorage.setItem(privateKeyName(userId), privateKeyB64)
}

export function getPrivateKey(userId) {
  return localStorage.getItem(privateKeyName(userId))
}

export function hasPrivateKey(userId) {
  return localStorage.getItem(privateKeyName(userId)) !== null
}

export function clearPrivateKey(userId) {
  localStorage.removeItem(privateKeyName(userId))
}

export function savePublicKey(userId, publicKeyB64) {
  localStorage.setItem(publicKeyName(userId), publicKeyB64)
}

export function getPublicKey(userId) {
  return localStorage.getItem(publicKeyName(userId))
}

export function clearAllKeys(userId) {
  localStorage.removeItem(privateKeyName(userId))
  localStorage.removeItem(publicKeyName(userId))
}
